import React, { useCallback } from "react";
import { withTranslation } from "react-i18next";
import styles from "./AddEvent.module.scss";
import "./AddEvent.scss";
import CustomDropdown from "components/Dropdown";
import Text from "components/Text";
import ToggleSwitch from "components/ToggleSwitch";
import { addEditEventsConst } from "./addEvents.constants";
import {
  arrayIntoString,
  getRepeatMessage,
  setterValuesAddedFilter,
} from "./addEvents.functions";
const {
  repeatEveryOptionsMap,
  days,
  weekdays,
  forYearlyMonthsArray,
  firstToLast,
  onTheWeekdays,
  repeatOptionsFrequency,
  dayMap,
} = addEditEventsConst;
const RepeatEventDropDowns = ({
  selectionType,
  selectedSlotDate,
  selectedWeek,
  selectedDay,
  selectedMonths,
  isDaySwitchOn,
  repeatedTypeEvery,
  repeatedTypeFrequency,
  setSchedule,
  setSelectedMonths,
  setSelectedSlotDate,
  schedule,
  setRepeatedTypeEvery,
  setRepeatedTypeFrequency,
  setSelectionType,
  setSelectedWeek,
  setSelectedDay,
  t,
  setIsDaySwitchOn,
  isFromBusySlot = false,
  eventOrShiftTab = false,
  hideMessage = false,
}) => {
  const getSelectedDayNames = useCallback(() => {
    if (schedule.length === 0) return "";

    const sortedDays = schedule.sort((a, b) => a - b).map((val) => dayMap[val]);

    return arrayIntoString(sortedDays);
  }, [schedule]);

  const repeatMessagesDisplay = () => {
    if (hideMessage) return null;
    return getRepeatMessage({
      repeatedTypeEvery,
      repeatedTypeFrequency,
      repeatOptionsFrequency,
      getSelectedDayNames,
      selectionType,
      selectedSlotDate,
      selectedWeek,
      selectedDay,
      selectedMonths,
      isDaySwitchOn,
      isFromBusySlot,
      isShift: eventOrShiftTab,
    });
  };

  const handleWeekDays = useCallback((event) => {
    const value = Number(event.target.value);
    setterValuesAddedFilter(setSchedule, value);
  }, []);
  const toggleMonthSelection = useCallback((month) => {
    setterValuesAddedFilter(setSelectedMonths, month);
  }, []);
  const daysSelectionForMonthEach = useCallback((day) => {
    setterValuesAddedFilter(setSelectedSlotDate, day);
  }, []);

  return (
    <>
      <div className={styles.frequency_daily_dropdown_wrapper}>
        <div className="c-field mb-2">
          <label>{t("accountOwner.frequency")}</label>
          <div className="custom-dropdown-only">
            <CustomDropdown
              options={repeatOptionsFrequency}
              selectedOption={repeatedTypeFrequency}
              selectOption={(id) => {
                setRepeatedTypeFrequency(id);
                setRepeatedTypeEvery(1);
              }}
            />
          </div>
        </div>
        <div className="c-field mb-2">
          <label>{t("accountOwner.every")}</label>
          <div className="custom-dropdown-only">
            <CustomDropdown
              options={repeatEveryOptionsMap[repeatedTypeFrequency] || []}
              selectedOption={repeatedTypeEvery}
              selectOption={(id) => {
                setRepeatedTypeEvery(id);
              }}
            />
          </div>
        </div>
      </div>

      {repeatedTypeFrequency === 2 && (
        <div className={styles["schedule-list"]}>
          <ul>
            {days.map((val, i) => (
              <li key={i + val.day}>
                <label>
                  <input
                    type="checkbox"
                    value={val.value}
                    checked={schedule.includes(val.value)}
                    onChange={handleWeekDays}
                  />
                  <span>{val.day}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}

      {repeatedTypeFrequency === 3 && (
        <div className={styles.calendar_radio_wrapper}>
          <div className={styles.monthly_calendar_radion_btn + " ch-radio"}>
            <label onClick={() => setSelectionType(true)}>
              <input
                type="radio"
                name="selectionType"
                checked={selectionType}
              />
              <span> {t("accountOwner.each")} </span>
            </label>
            <label onClick={() => setSelectionType(false)}>
              <input
                type="radio"
                name="selectionType"
                checked={!selectionType}
              />
              <span>{t("accountOwner.onThe")}</span>
            </label>
          </div>
          {selectionType ? (
            <div className="frequency_every_calendar">
              <div className={styles["calendar-grid"]}>
                {Array.from({ length: 31 }, (r, i) => i + 1).map((res) => (
                  <button
                    key={res + "calender"}
                    onClick={() => {
                      daysSelectionForMonthEach(res);
                    }}
                  >
                    <span
                      className={
                        selectedSlotDate.includes(res)
                          ? styles["active-date"]
                          : ""
                      }
                    >
                      {res}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          ) : (
            <div className={styles.on_the_dropdown + " custom-dropdown-only"}>
              <CustomDropdown
                options={firstToLast}
                selectedOption={selectedWeek}
                selectOption={(id) => setSelectedWeek(id)}
              />
              <CustomDropdown
                options={onTheWeekdays}
                selectedOption={selectedDay}
                selectOption={(id) => setSelectedDay(id)}
              />
            </div>
          )}

          <Text size="11px" weight="400" color="#79869A">
            {repeatMessagesDisplay()}
          </Text>
        </div>
      )}

      {repeatedTypeFrequency === 4 && (
        <div className={styles.yealy_content_wrapper}>
          <div className={styles.month_grid}>
            {forYearlyMonthsArray.map((month) => (
              <div
                key={month.id}
                className={`${styles.month_box} ${
                  selectedMonths.includes(month.id) ? styles.active : ""
                }`}
                onClick={() => toggleMonthSelection(month.id)}
              >
                {month.name}
              </div>
            ))}
          </div>
          <hr />
          <div className="d-flex justify-content-between mt-2">
            <Text size="14" weight="600" color="#2F3245">
              {t("accountOwner.daysOfWeek")}
            </Text>
            <ToggleSwitch
              label="daysOfWeek"
              value={isDaySwitchOn}
              onChange={(e) => {
                setIsDaySwitchOn(e.target.checked);
              }}
            />
          </div>

          <div
            className={
              styles.on_the_dropdown +
              " custom-dropdown-only " +
              (isDaySwitchOn ? "" : styles.opacity)
            }
          >
            <CustomDropdown
              options={firstToLast}
              selectedOption={selectedWeek}
              selectOption={(id) => setSelectedWeek(id)}
              disabled={!isDaySwitchOn}
            />
            <CustomDropdown
              options={weekdays}
              selectedOption={selectedDay}
              selectOption={(id) => setSelectedDay(id)}
              disabled={!isDaySwitchOn}
            />
          </div>
          <Text size="11px" weight="400" color="#79869A" marginTop="10px">
            {repeatMessagesDisplay()}
          </Text>
        </div>
      )}

      {(repeatedTypeFrequency === 1 || repeatedTypeFrequency === 2) && (
        <Text size="11px" weight="400" color="#79869A">
          {repeatMessagesDisplay()}
        </Text>
      )}
    </>
  );
};
export default withTranslation()(RepeatEventDropDowns);
